import { KINDLY_SESSION_STORAGE_KEY, KINDLY_SESSION_STATUS, VIEWS_WITHOUT_KINDLY } from '@constants/kindly';
import { Config } from '@common/Config/types';
import { get } from '@helpers/localStorage';

export const openKindlyChat = () => {
    /* @ts-ignore */
    window?.kindlyChat?.openChat();
};

export const isKindlyMessageActiveInview = ({ controller }:Config) => controller === 'layout' || controller === 'profile';

export const isKindlyActiveInView = ({ controller }:Config) => !VIEWS_WITHOUT_KINDLY.includes(controller);

export const isKindlyActive = (config: Config) => {
    const kindlySessionStatus = get(KINDLY_SESSION_STORAGE_KEY);
    return kindlySessionStatus === KINDLY_SESSION_STATUS.active
    || isKindlyActiveInView(config);
};

export const getKindlyButtonLocation = ({ controller, trackingPageViewUrl }: Config) => {
    const isCsRoute = trackingPageViewUrl.includes('/customer-service');
    const kindlySessionStatus = get(KINDLY_SESSION_STORAGE_KEY);

    if (isCsRoute || controller === 'profile' || kindlySessionStatus === KINDLY_SESSION_STATUS.active) {
        return 'sticky';
    }

    if (controller === 'shopcart' || controller === 'product') {
        return 'footer_only';
    }

    return 'footer_sticky';
};

// old events to be removed once new app version rolls out and is tested
export const handleAppEventsLegacy = (event: string) => {
    // @ts-ignore
    const hasWebkitMessageHandlers = window?.webkit?.messageHandlers;

    try {
        if (hasWebkitMessageHandlers) {
            // @ts-ignore
            window.webkit.messageHandlers.freshchat.postMessage({
                event,
            });
        }

        // @ts-ignore
        if (/(android)/i.test(navigator.userAgent) && typeof FreshchatAndroidInterface !== 'undefined') {
            // eslint-disable-next-line no-undef
            // @ts-ignore
            FreshchatAndroidInterface.sendFreshchatEvent(JSON.stringify({
                event,
            }));
        }
    } catch (error) {
        console.log(error);
    }
};

// New version
export const handleAppEvents = (event: string) => {
    // @ts-ignore
    const hasWebkitMessageHandlers = window?.webkit?.messageHandlers;

    try {
        // New events for testing
        if (hasWebkitMessageHandlers) {
            // @ts-ignore
            window.webkit.messageHandlers.chatAppInterface.postMessage({
                event,
            });
        }

        // @ts-ignore
        if (/(android)/i.test(navigator.userAgent) && typeof ChatAppInterface !== 'undefined') {
            // eslint-disable-next-line no-undef
            // @ts-ignore
            ChatAppInterface.sendChatEvent(JSON.stringify({
                event,
            }));
        }
    } catch (error) {
        console.log(error);
    }
};
